import { Box, Grid, Typography } from '@mui/material';
import ColorPicker from 'components/ColorPicker/ColorPicker';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import { TITLE_MAX_LENGTH } from '../constants';
import WordCounterField from '../WordCounterField';

interface TitleSectionProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
  titleEnCount: number;
  titleHuCount: number;
  setTitleEnCount: (count: number) => void;
  setTitleHuCount: (count: number) => void;
  titleColor?: string;
  onTitleColorChange?: (color: string) => void;
}

export default function TitleSection({
  control,
  errors,
  titleEnCount,
  titleHuCount,
  setTitleEnCount,
  setTitleHuCount,
  titleColor = '',
  onTitleColorChange = () => {
    /* no-op */
  },
}: TitleSectionProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <Typography
        variant="subtitle1"
        sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}
      >
        {t('createGuiVersionPage.title')}
        <ColorPicker value={titleColor} onChange={onTitleColorChange} />
      </Typography>

      <Box display="flex" gap={2} width="100%">
        <Box flex="1">
          <WordCounterField
            name="titleEn"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.titleEn')}
            maxLength={TITLE_MAX_LENGTH}
            currentCount={titleEnCount}
            onCountChange={setTitleEnCount}
          />
        </Box>
        <Box flex="1">
          <WordCounterField
            name="titleHu"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.titleHu')}
            maxLength={TITLE_MAX_LENGTH}
            currentCount={titleHuCount}
            onCountChange={setTitleHuCount}
          />
        </Box>
      </Box>
    </Grid>
  );
}
